import React, { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { observer } from "mobx-react-lite";
import RequireAuth from '../RequireAuth';
import AuthContext from "../../context/AuthProvider";
import MainNavBar from "./MainNavBar";
import MainFooter from "./MainFooter";
import Layout from './Layout';
import NotFound from "../NotFound";
import { getRoutesByRole } from "../../config/routes";

const MainLayout = () => {
  const { auth } = useContext(AuthContext);

  const renderRoutes = () => {
    const userRoutes = getRoutesByRole(auth?.role);
    
    return userRoutes.map(route => (
      <Route 
        key={route.path} 
        path={route.path} 
        element={route.element} 
      />
    ));
  };

  return (
    <>
      <MainNavBar />
      <main className="main-content-horizontal">
        <div className="container-fluid">
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route element={<RequireAuth allowedRoles={['admin']} />}>
                {renderRoutes()}
              </Route>
            </Route>
            <Route path="/*" element={<NotFound />} />
          </Routes>
          <MainFooter />
        </div>
      </main>
    </>
  );
};

export default observer(MainLayout);
